import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, MapPin } from 'lucide-react';
import { bookingUrl, images } from '../data/site';
const ease = [0.22, 1, 0.36, 1] as const;
export function Hero() {
  return <section id="home" className="relative flex min-h-[100svh] w-full items-end overflow-hidden bg-ocean-deep" data-id="element-131" data-mp="9luzmm7107tq">
      <motion.img src={images.hero} alt="Rainforest hillside dropping down to a turquoise bay on the coast of Taveuni, Fiji" fetchPriority="high" decoding="async" className="absolute inset-0 h-full w-full object-cover object-[68%_50%] sm:object-center" initial={{
      scale: 1.12,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 1.8,
      ease
    }} data-id="element-132" data-mp="4njnu5x67n8v" />
      <div className="absolute inset-0 bg-gradient-to-t from-ocean-deep/92 via-ocean-deep/45 to-ocean-deep/40" data-id="element-133" data-mp="3d1a99mbhsfec" />
      <div className="absolute inset-0 bg-gradient-to-r from-ocean-deep/55 via-transparent to-transparent" data-id="element-134" data-mp="381xiwrlewq70" />

      <div className="relative mx-auto w-full max-w-[1400px] px-5 pb-16 pt-32 sm:px-8 sm:pb-20 lg:px-12 lg:pb-24" data-id="element-135" data-mp="3j893b0s41pjq">
        <motion.div className="flex items-center gap-2.5 text-[11px] font-medium uppercase tracking-wider-xl text-ivory/80" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.8,
        ease
      }} data-id="element-136" data-mp="3o6arg04e8f22">
          <MapPin className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-137" data-mp="30gzuyuu2t6tq" />
          Taveuni, Fiji
        </motion.div>

        <motion.h1 className="mt-6 max-w-4xl font-serif text-[clamp(2.75rem,9vw,7rem)] font-light leading-[0.95] tracking-[0.01em] text-ivory" initial={{
        opacity: 0,
        y: 28
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.55,
        duration: 1,
        ease
      }} data-id="element-138" data-mp="35aaueawk6lbm">
          Your Home
          <span className="block italic text-gold-soft" data-id="element-139" data-mp="2hl9q8zurdwc5">in Taveuni</span>
        </motion.h1>

        <motion.div className="mt-8 max-w-xl border-l border-gold/50 pl-5" initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.75,
        duration: 0.9,
        ease
      }} data-id="element-140" data-mp="2lmv00cbzxui4">
          <p className="font-serif text-2xl italic text-ivory/95 sm:text-[28px]" data-id="element-141" data-mp="iboyiltrcouw">
            Stay local. Wake up in paradise.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-ivory/75" data-id="element-142" data-mp="deq92gl1h631">
            A peaceful tropical homestay in Taveuni, Fiji, with homemade
            breakfast included.
          </p>
        </motion.div>

        <motion.div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.95,
        duration: 0.9,
        ease
      }} data-id="element-143" data-mp="162m3tfr1snx6">
          <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="rounded-full bg-ivory px-8 py-4 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-forest-deep transition-all duration-300 ease-calm hover:-translate-y-0.5 hover:bg-gold hover:shadow-lift" data-id="element-144" data-mp="3lt740mm25js5">
            Book your stay
          </a>
          <a href="#taveuni" className="rounded-full border border-ivory/45 px-8 py-4 text-center text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory transition-all duration-300 ease-calm hover:-translate-y-0.5 hover:border-ivory hover:bg-ivory/10" data-id="element-145" data-mp="269r3nvyj5iak">
            Explore Taveuni
          </a>
        </motion.div>

        <motion.a href="#intro" aria-label="Scroll to content" className="mt-14 hidden items-center gap-3 text-[10px] uppercase tracking-wider-xl text-ivory/55 transition-colors hover:text-ivory lg:inline-flex" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.3,
        duration: 1
      }} data-id="element-146" data-mp="2l0qbv5vge4tm">
          <ArrowDown className="h-4 w-4 animate-bounce" aria-hidden="true" data-id="element-147" data-mp="zm2kx98dpyc5" />
          Scroll
        </motion.a>
      </div>
    </section>;
}